
import { Component, Vue, toNative, Watch } from 'vue-facing-decorator';
import { Twitter } from '@ckpack/vue-color';
import vClickOutside from 'click-outside-vue3';
import Datepicker from '../Common/Datepicker.vue';
import AddURL from '../Common/AddUrl.vue';
import ImageProcess from '../Common/ImageProcess.vue';
import Editor from '@/components/Common/Editor.vue';
import MapPicker from '@/components/Common/MapPicker.vue';
import SubModulePrefix from '@/enums/SubModulePrefix';
import WarningMessageBar from '../Common/WarningMessageBar.vue';
import ValidationSummary from '@/components/Common/ValidationSummary.vue';
import { WarningMessageBarViewModel } from '@/entities/WarningMessageBarViewModel';
import DetailModalPopup from '../Common/DetailModalPopup.vue';
import EventWebPageViewModel from '@/entities/EventWebPages/EventWebPageViewModel';
import EventWebPageButtonType from '@/enums/EventWebPageButtonType';
import { DetailModalPopupViewModel } from '@/entities/DetailModalPopupViewModel';
import loading from '@/components/Common/loading.vue';
import Common from '@/helper/Common';
import { StoreHelper } from '@/store/StoreHelper';
import { AppRequestInfo } from '@/entities/AppRequestInfo';
import VueModalPopUp from '../Common/VueModalPopUp.vue';
import { VueModalPopUpViewModel } from '@/entities/VueModalPopUpViewModel';
import EventWebPageHelper from '@/helper/EventWebPageHelper';
import { BrowserSettingsInfo } from '@/entities/BrowserSettingsInfo';
import moment from 'moment-timezone';
import AnalyticsModalPopupViewModel from '@/entities/AnalyticsModalPopupViewModel';
import AnalyticsModalPopup from '@/components/Common/AnalyticsModalPopup.vue';
import AnalyticsModalPopupDataViewModel from '@/entities/AnalyticsModalPopupDataViewModel';
import { Store, app, FetchData, Root } from '@/main';
import Toaster from '../Common/Toaster.vue';
import ImageContainer from '../Common/ImageContainer.vue';
import ImageContainerViewModel from '@/entities/ImageContainerViewModel';
import EventWebPagesMetaDataViewModel from '@/entities/EventWebPages/EventWebPagesMetaDataViewModel';
import EventWebPageCustomSectionsViewModel from '@/entities/EventWebPages/EventWebPageCustomSections/EventWebPageCustomSectionsViewModel';
import EventWebPageSectionType from '@/enums/EventWebPage/EventWebPageSectionType';
import EventWebPageOGImageType from '@/enums/EventWebPageOGImageType';

@Component({
  components: {
    AddURL,
    Editor,
    MapPicker,
    Datepicker,
    ImageProcess,
    WarningMessageBar,
    ValidationSummary,
    DetailModalPopup,
    loading,
    Toaster,
    VueModalPopUp,
    AnalyticsModalPopup,
    Twitter,
    ImageContainer,
    vClickOutside,
  },
})
class EventWebpageEditPane extends Vue {
  private PrimaryBackgroundColor = {hex: ''};
  private PrimaryFontColor = {hex: ''};
  private HeaderFooterBackgroundColor = {hex: ''};
  private HeaderFooterFontColor = {hex: ''};
  private ButtonAccentBackgroundColor = {hex: ''};
  private ButtonAccentFontColor = {hex: ''};
  private LinkFontColor = {hex: ''};
  private fontAppearance = EventWebPageHelper.FontAppearance;
  private isMobileView = false;
  // Used to show message when page contains changes and is not saved
  private warningMessage: WarningMessageBarViewModel = WarningMessageBarViewModel.createEmpty();
  // Used to show message when the page is disabled i.e., in case of mobile view
  private informationMessage: WarningMessageBarViewModel = WarningMessageBarViewModel.createEmpty();
  // Used to show message when invitee is not published
  private inviteeWarningMessage: WarningMessageBarViewModel = WarningMessageBarViewModel.createEmpty();
  private isPaletteSelected = [false,false,false,false,false,false,false];
  private missingImage: string = require('@/assets/Images/ImageMissingFeature.png');
  private featureMissingImage: string = require('@/assets/Images/icon-placeholder.svg');
  private showFeaturedImage = false;
  private showImageProcess = false;
  private moduleName = 'EventWebPage';
  private subModuleName = '';
  private isPopupVisible = false;
  private isButtonUrlValid = false;
  private addIcon = require('@/assets/Images/add-icon-grey.svg');
  private previewIcon = require('@/assets/Images/preview-icon.svg');
  private infoIcon = require('@/assets/Images/info-icon.svg');
  private copiedIcon: string = require('@/assets/Images/link_icon_small.svg');
  private analyticsIcon: string = require('@/assets/Images/analytics-icon.svg');
  private dropDownIcon = require('@/assets/Images/down-arrow-white.svg');
  private eventWebPageData: EventWebPageViewModel = EventWebPageViewModel.createEmpty();
  private oldEventWebPageData: EventWebPageViewModel = EventWebPageViewModel.createEmpty();
  private detailModalPopupData: DetailModalPopupViewModel = DetailModalPopupViewModel.createEmpty();
  private isPageDirty = false;
  private showLoading = false;
  private showToaster = false;
  private toasterDefaultTimeout = EventWebPageHelper.ToasterTimeOut;
  private toasterMessage = '';
  private loaderBorderColor = '';
  private minDateTime = new Date().toISOString();
  private isValidationSummaryVisible = false;
  private validationErrorFields: string[] = [];
  private popupButton1Text = '';
  private popupButton2Text = '';
  private staticPath = process.env.VUE_APP_EVENTWEBPAGEURL;
  private isPublished = false;
  private isSavedAndPublished = false;
  private maxTitleLength = EventWebPageHelper.MaxTitleLength;
  private maxInputFieldLength = EventWebPageHelper.maxInputFieldLength;
  private showVueModalPopUp = false;
  private publishModalPopUp: VueModalPopUpViewModel = VueModalPopUpViewModel.createEmpty();
  private eventPaths: string[] = [];
  private storeHelper: StoreHelper = new StoreHelper(Store);
  private maxNavBarItems = EventWebPageHelper.MaxNavBarItems;
  private isIEbrowser = false;
  private timeZones = this.storeHelper.GetActiveEventIanaTimeZoneFromStore();
  private dateFormat: Intl.DateTimeFormat = new Intl.DateTimeFormat();
  private isUrlRequired = true;
  private externalLinkUrl = '';
  private register = 'Register';
  private showOverlayInfo = false;
  private showCopiedMessage = false;
  private linkCopiedFadeoutTime = EventWebPageHelper.LinkCopiedFadeoutTime;
  private analyticsModalPopUp: AnalyticsModalPopupViewModel = AnalyticsModalPopupViewModel.createEmpty();
  private showAnalyticsModalPopup = false;
  private isDataLoaded = false;
  private eventPageLogoData: ImageContainerViewModel = ImageContainerViewModel.createEmpty();
  private eventPageBannerImageData: ImageContainerViewModel = ImageContainerViewModel.createEmpty();
  private eventPageOrganizerImageData: ImageContainerViewModel = ImageContainerViewModel.createEmpty();
  private clickedImageType = 0; // This is used to get the image type(i.e., banner, organizer or custom section)
  private selectedCustomSectionIndex = 0; // This is used to get the index of the currently selected custom section
  private customSectionImageContainerData: ImageContainerViewModel[] = []; // This is for having image container data for multiple custom sections
  private deletedCustomSection: EventWebPageCustomSectionsViewModel[] = []; // This is used to store deleted items which were saved previously
  private eventPageOGImageData: ImageContainerViewModel = ImageContainerViewModel.createEmpty();
  private isOGImageSelected = false;
  private isLogoImageClicked = false;
  private isSocialSharingGuidelineClicked = false;
  public get selectedButtonType(): typeof EventWebPageButtonType {
    return EventWebPageButtonType;
  }
  public get selectedOGImageType(): typeof EventWebPageOGImageType {
    return EventWebPageOGImageType;
  }
  private mounted() {
    if (navigator.appName === 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))) {
      this.isIEbrowser = true;
    }
    this.InitializeTimeFormat();
    this.GetEventWebPageData();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    app.use(vClickOutside);
    // Check if current view is mobile view
    if (window.innerWidth <= 767) {
      this.isMobileView = true;
    } else {
      this.isMobileView = false;
    }
    this.popupButton1Text = this.$t('CancelButton').toString();
    this.popupButton2Text = this.$t('Publish').toString();
    // Setting value for message to be displayed in mobile view
    this.informationMessage = new WarningMessageBarViewModel(
      '',
      this.$t('EventWebpage.WebpageReadOnlyMode').toString() ,
      this.$t('InformationAlert').toString() ,
    );
    // Setting message to be displayed when page have changes to be saved
    this.warningMessage = new WarningMessageBarViewModel(
      this.infoIcon,
      this.$t('EventWebpage.SaveToReflectChangesInPrevew').toString() ,
      this.$t('EventSetting.EventInformation').toString() ,
    );
    // Setting message to be displayed when invitee is on but not published yet and selected button type is 'use ventla invite'
    this.inviteeWarningMessage = new WarningMessageBarViewModel(
      this.infoIcon,
      this.$t('EventWebpage.UnpublishedInviteURL').toString() ,
      this.$t('EventSetting.EventInformation').toString() ,
    );
    this.SetLogoData();
    this.SetBannerImageData();
    this.SetOrganizerImageData();
    this.SetOGImageData();
    Root.on('SetFeaturedImageIconUrl',(val: string)=> {
      this.SetBackgroundImageUrl(val);
    });
  }
  private SetLogoData() {
    this.eventPageLogoData.ImageDescription = this.GetLogoWarning();
    this.eventPageLogoData.ImageUrl = this.eventWebPageData.EventWebPagesMetaData.LogoURL;
    this.eventPageLogoData.ShowImageDescription = true;
    this.eventPageLogoData.DescriptionMargin = '25px 0px 0px';
    this.eventPageLogoData.ImageHeading = this.$t('EventWebpage.LogoForWebpage').toString();
    this.eventPageLogoData.ShowImageHeading = true;
  }
  private SetBannerImageData() {
    this.eventPageBannerImageData.ImageDescription = this.GetBackgroundImageWarning();
    this.eventPageBannerImageData.ShowImageDescription = true;
    this.eventPageBannerImageData.ImageUrl = this.eventWebPageData.EventWebPagesMetaData.BannerImageURL;
    this.eventPageBannerImageData.IsLogoMandatory = true;
    this.eventPageBannerImageData.ImageHeading = this.$t('EventWebpage.BannerImage').toString();
    this.eventPageBannerImageData.ShowImageHeading = true;
    this.eventPageBannerImageData.DescriptionMargin = '25px 0px 0px';
  }
  private SetOrganizerImageData() {
    this.eventPageOrganizerImageData.ImageDescription = this.GetBackgroundImageWarning();
    this.eventPageOrganizerImageData.ShowImageDescription = true;
    this.eventPageOrganizerImageData.ImageUrl = this.eventWebPageData.EventWebPagesMetaData.BannerImageURL;
  }
  private SetOGImageData() {
    this.eventPageOGImageData.ImageDescription = this.GetOGImageWarning();
    this.eventPageOGImageData.ShowImageDescription = true;
    this.eventPageOGImageData.ImageUrl = this.eventWebPageData.EventWebPagesMetaData.OGImageUrl;
    this.eventPageOGImageData.IsLogoMandatory = true;
    this.eventPageOGImageData.ImageHeading = this.$t('EventWebpage.SocialSharingImage').toString();
    this.eventPageOGImageData.ShowImageHeading = true;
    this.eventPageOGImageData.DescriptionMargin = '25px 0px 0px';
    this.eventPageOGImageData.ShowHelperLink = true;
    this.eventPageOGImageData.HelperLinkText = this.$t('EventWebpage.SocialImageBestPractices').toString();
  }
  // Get data from DB
  private GetEventWebPageData() {
    this.showLoading = true;
    FetchData('/EventWebPage/GetEventWebPageViewModel','').then((data)=> {
      // Setting values received
      this.eventWebPageData = JSON.parse(JSON.stringify(data));
      this.oldEventWebPageData = JSON.parse(JSON.stringify(data));
      if(this.eventWebPageData.EventWebPagesMetaData.CTAButtonType === EventWebPageButtonType.VentlaInviteLink) {
        this.isUrlRequired = false;
      }
      if(this.eventWebPageData.EventWebPagesMetaData.CTAButtonType === EventWebPageButtonType.ExternalLink) {
        this.externalLinkUrl = this.eventWebPageData.EventWebPagesMetaData.CTAButtonURL;
      }
      // Storing all the previous path used in an application
      this.GetEventsPath(this.eventWebPageData.AppId);
      this.IsPageDirty();
      this.SetModalPopupData();
      this.SetCustomSectionImageContainerData();
      this.deletedCustomSection = [];
      setTimeout(() => {
        this.showLoading = false;
      }, 1000);
      // Showing page when data is loaded preventing css issue in mac
      if(this.eventWebPageData !== null && this.eventWebPageData !== undefined) {
        this.isDataLoaded = true;
      }
      this.SetDefaultColors();
    })
      .catch(() => {
        this.showLoading = false;
      });
  }
  // Get all events path name in an application
  private GetEventsPath(id: number) {
    FetchData('/EventWebPage/GetEventWebPagesPathList', JSON.stringify({
      appId: id,
    })).then((response) => {
      // Storing all the paths by converting them to lower case except the current path
      response.forEach((element: string) => {
        if(element.toLowerCase() !== this.eventWebPageData.EventWebPages.Path.toLowerCase()) {
          this.eventPaths.push(element.toLowerCase());
        }
      });
    })
      .catch(() => {
        // error
      });
  }
  // Get web page analytics
  private GetWebPageAnalytics() {
    const eventPath = '/' + this.eventWebPageData.AppEncodedName + '/' + this.eventWebPageData.EventWebPages.EncodedPath;
    FetchData('/Analytics/GetEventWebPagesLogs',JSON.stringify({
      path: eventPath,
    })).then((response) => {
      this.analyticsModalPopUp = AnalyticsModalPopupViewModel.createEmpty();
      this.analyticsModalPopUp.Heading = this.$t('EventWebpage.EventPageAnalytics').toString();
      // Setting value for views and interactions on event page
      const viewAndInteractions: AnalyticsModalPopupDataViewModel = {
        SubHeading: this.$t('EventWebpage.EventPageAnalytics.ViewsAndInteractions').toString(),
        Data: [{
          key: this.$t('EventWebpage.EventPageAnalytics.PageViews').toString(),
          value: response.TotalPageViews,
        }, {
          key: this.$t('EventWebpage.EventPageAnalytics.ButtonClicks').toString(),
          value: response.TotalCTACount,
        }],
      };
        // Setting value for interactions on different devices
      const devicesData = response.EventWebPageMobileBrowserLogs.map((item: { IsMobileBrowser: any; PageViews: any }) => {
        if(item.IsMobileBrowser) {
          return {
            key: this.$t('Mobile').toString(),
            value: item.PageViews,
          };
        } else {
          return {
            key: this.$t('Desktop').toString(),
            value: item.PageViews,
          };
        }
      });
      const viewByDevices: AnalyticsModalPopupDataViewModel = {
        SubHeading: this.$t('EventWebpage.EventPageAnalytics.ViewsByDeviceType').toString(),
        Data: devicesData,
      };
      response.EventWebPageCountryLogs.sort((item1: { PageViews: number }, item2: { PageViews: number })=> item2.PageViews - item1.PageViews);
      // Setting value according to the intercation among different origins
      const originsData = response.EventWebPageLocationLogs.map((item: { City: string; Country: string; PageViews: any }) => ({key: item.City + ', ' + item.Country, value: item.PageViews}));
      originsData.splice(EventWebPageHelper.MaxOriginToBeDisplayed);
      const viewsByOrigin: AnalyticsModalPopupDataViewModel = {
        SubHeading: this.$t('EventWebpage.EventPageAnalytics.ViewsByTopOrigins').toString(),
        Data: originsData,
      };
        // Adding data to analyticsModalPopUp to pass to the popup component
      this.analyticsModalPopUp.AnalyticsData.push(viewAndInteractions);
      this.analyticsModalPopUp.AnalyticsData.push(viewByDevices);
      this.analyticsModalPopUp.AnalyticsData.push(viewsByOrigin);
      this.showAnalyticsModalPopup = true;
    })
      .catch(() => {
        // error
      });
  }
  // Set default values for palette
  private SetDefaultColors() {
    this.PrimaryBackgroundColor.hex = this.eventWebPageData.EventWebPageThemeSettings.PrimaryBackgroundColor;
    this.PrimaryFontColor.hex = this.eventWebPageData.EventWebPageThemeSettings.PrimaryFontColor;
    this.HeaderFooterBackgroundColor.hex = this.eventWebPageData.EventWebPageThemeSettings.HeaderFooterBackgroundColor;
    this.HeaderFooterFontColor.hex = this.eventWebPageData.EventWebPageThemeSettings.HeaderFooterFontColor;
    this.ButtonAccentBackgroundColor.hex = this.eventWebPageData.EventWebPageThemeSettings.ButtonAccentBackgroundColor;
    this.ButtonAccentFontColor.hex = this.eventWebPageData.EventWebPageThemeSettings.ButtonAccentFontColor;
    this.LinkFontColor.hex = this.eventWebPageData.EventWebPageThemeSettings.LinkFontColor;
  }
  // Used for describing the current state of page
  private GetInformationMessage() {
    if(!this.eventWebPageData.EventWebPages.IsPublished) {
      // If page is not published
      return this.$t('EventWebpage.PageNotPublishedYet');
    } else if(this.eventWebPageData.EventWebPagesMetaData.UpdatedOn > this.eventWebPageData.EventWebPages.PublishedDate) {
      // If page is published and have saved draft yet to be published
      return this.$t('EventWebpage.LatestChangesNotPublishedYet',{lastPublished: this.$t('EventWebpage.LastPublisedDate',{date: this.FormatDateTime(this.eventWebPageData.EventWebPages.PublishedDate)})});
    } else {
      // If page is published and doesn't have any saved draft
      return this.$t('EventWebpage.LastPublisedDate',{date: this.FormatDateTime(this.eventWebPageData.EventWebPages.PublishedDate)});
    }
  }
  private InitializeTimeFormat() {
    const browsersettings: BrowserSettingsInfo = this.storeHelper.GetBrowserSettingsFromStore();
    // if timezone is allowed in application then date times will be formatted accordingly
    if (this.timeZones !== '' && this.timeZones !== null && !this.isIEbrowser) {
      this.dateFormat = new Intl.DateTimeFormat(browsersettings.locale, {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZone: this.timeZones,
      });
    } else {
      this.dateFormat = new Intl.DateTimeFormat(browsersettings.locale, {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      });
    }
  }
  // Used for formatting the date and time
  private FormatDateTime(date: Date) {
    if (date !== null && date !== undefined) {
      const datepublished: Date = moment(date).toDate();
      if (!this.isIEbrowser) {
        // For all browser (except IE) date is formatted with browser settings
        return this.dateFormat.format(datepublished).toUpperCase();
      } else {
        // For IE browser date is formatted manually
        const ieDateForamt = moment(datepublished).tz(this.timeZones).format('DD-MM-YYYY, h:mm a');
        return ieDateForamt;
      }
    }
  }
  // Used for setting the button url to ventla invitee when 'use ventla invitee' is clicked
  private SetVentlaInviteLink() {
    if(this.eventWebPageData.InviteUrl !== null && this.eventWebPageData.InviteUrl !== undefined) {
      this.eventWebPageData.EventWebPagesMetaData.CTAButtonType = EventWebPageButtonType.VentlaInviteLink;
      this.isUrlRequired = false;
      if (this.eventWebPageData.EventWebPagesMetaData.CTAButtonTitle === '') {
        this.eventWebPageData.EventWebPagesMetaData.CTAButtonTitle =this.register;
      }
      this.eventWebPageData.EventWebPagesMetaData.CTAButtonURL = this.eventWebPageData.InviteUrl;
    }
  }
  // Used for removing the ventla invitee link when 'use external link' is clicked
  private SetExternalLink() {
    this.isUrlRequired = true;
    if (this.eventWebPageData.EventWebPagesMetaData.CTAButtonTitle === '') {
      this.eventWebPageData.EventWebPagesMetaData.CTAButtonTitle =this.register;
    }
    this.eventWebPageData.EventWebPagesMetaData.CTAButtonURL = this.externalLinkUrl;
  }
  // Used for setting the data for popup having the path name and check for hiding page from appering in search
  private SetModalPopupData() {
    this.detailModalPopupData = new DetailModalPopupViewModel(this.$t('PublishSettings').toString() ,this.$t('EventWebpage.WebAddres').toString() ,this.$t('EventWebpage.Indexing').toString() ,this.eventWebPageData.AppEncodedName,this.eventWebPageData.EventWebPages.Path, this.eventWebPageData.EventWebPages.EncodedPath, this.staticPath, this.eventPaths, this.$t('EventWebpage.InvalidUrl').toString() , this.eventWebPageData.EventWebPages.HidePageFromSearchEngines,this.$t('EventWebpage.HideFromSearchEngines').toString() , this.popupButton1Text,this.popupButton2Text, this.eventWebPageData.EventWebPages.GoogleTagId);
  }
  // Receives boolean value from AddURL stating whether entered URL is valid or not
  private IsValidUrl(val: boolean) {
    this.isButtonUrlValid = val;
  }
  // Setting button url value entered by admin
  private SetUrl(url: string) {
    this.eventWebPageData.EventWebPagesMetaData.CTAButtonURL = url;
    if(this.eventWebPageData.EventWebPagesMetaData.CTAButtonType === EventWebPageButtonType.ExternalLink) {
      this.externalLinkUrl = url;
    }
  }
  // Used to hide any palette opened
  private HideAllPalattes() {
    this.isPaletteSelected.forEach((element, index) => {
      this.isPaletteSelected[index] = false;
    });
  }
  // Used to show the particular palette clicked
  private TogglePalette(index: number) {
    this.HideAllPalattes();
    if(!this.isMobileView) {
      this.isPaletteSelected[index] = !this.isPaletteSelected[index];
    }
  }
  // Used to show/hide image process
  private ShowImageProcessSection(): boolean {
    return this.showImageProcess;
  }
  private ClickOnImage(val: boolean) {
    if(!this.isMobileView) {
      this.showImageProcess = val;
      this.showFeaturedImage = false;
      this.subModuleName = SubModulePrefix.IconImage;
    }
  }
  private HandleImageClick(val: boolean, isLogoImageClicked = false) {
    if(!this.isMobileView) {
      this.showImageProcess = val;
      this.showFeaturedImage = false;
      this.subModuleName = isLogoImageClicked ? SubModulePrefix.IconImage : SubModulePrefix.OGImage;
      this.isLogoImageClicked = isLogoImageClicked;
    }
  }
  private SetOGImageUrl(val = 0) {
    if (val === this.selectedOGImageType.UseLogoAsSocialImage) {
      this.eventWebPageData.EventWebPagesMetaData.OGButtonType = this.selectedOGImageType.UseLogoAsSocialImage;
    } else{
      this.eventWebPageData.EventWebPagesMetaData.OGButtonType = this.selectedOGImageType.CustomSocialImage;
    }
  }
  // Returning value of logo image to be displayed
  private GetLocalLogoImageUrl() {
    return this.eventWebPageData.EventWebPagesMetaData.LogoURL === null || this.eventWebPageData.EventWebPagesMetaData.LogoURL === '' ? this.addIcon : this.eventWebPageData.EventWebPagesMetaData.LogoURL;
  }
  // Returning value of banner image to be displayed
  private GetLocalBannerImageUrl() {
    return this.eventWebPageData.EventWebPagesMetaData.BannerImageURL === null || this.eventWebPageData.EventWebPagesMetaData.BannerImageURL === '' ? this.addIcon : this.eventWebPageData.EventWebPagesMetaData.BannerImageURL;
  }
  // Returning value of organizer image to be displayed
  private GetLocalOrganizerImageUrl() {
    return this.eventWebPageData.EventWebPagesMetaData.OrganizerImageUrl === null || this.eventWebPageData.EventWebPagesMetaData.OrganizerImageUrl === '' ? this.addIcon : this.eventWebPageData.EventWebPagesMetaData.OrganizerImageUrl;
  }
  // Get feature image according to type of section clicked(Banner or organizer or custom section)
  private GetFeaturedImageUrl() {
    if(this.clickedImageType === EventWebPageSectionType.OrganizerSection) {
      return (this.eventWebPageData.EventWebPagesMetaData.OrganizerImageUrl === null || this.eventWebPageData.EventWebPagesMetaData.OrganizerImageUrl === '') ? this.featureMissingImage : this.eventWebPageData.EventWebPagesMetaData.OrganizerImageUrl;
    } else if(this.clickedImageType === EventWebPageSectionType.BannerSection) {
      return (this.eventWebPageData.EventWebPagesMetaData.BannerImageURL === null || this.eventWebPageData.EventWebPagesMetaData.BannerImageURL === '') ? this.featureMissingImage : this.eventWebPageData.EventWebPagesMetaData.BannerImageURL;
    } else {
      // Check whether custom sections are neither null nor undefined
      if(!!this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections && !!this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections[this.selectedCustomSectionIndex]) {
        return (this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections[this.selectedCustomSectionIndex].SectionImageUrl === null || (this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections[this.selectedCustomSectionIndex].SectionImageUrl === '' && this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections[this.selectedCustomSectionIndex].IsDeleted)) ? this.featureMissingImage : this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections[this.selectedCustomSectionIndex].SectionImageUrl;
      } else {
        return this.featureMissingImage;
      }
    }
  }
  // Changing background image for either banner or organizer section based on particular section clicked
  private ClickOnBackgroundImage(sectionType: number, IsDisabled: boolean, customSectionIndex = 0) {
    if(!this.isMobileView && !IsDisabled) {
      this.showImageProcess = true;
      this.subModuleName = SubModulePrefix.BackgroundImage;
      this.showFeaturedImage = true;
      this.clickedImageType = sectionType;
      this.selectedCustomSectionIndex = customSectionIndex;
    }
  }

  // Set logo image url
  private SetlogoUrl(imgurl: string, _mainMediaFullUrl: string, IsLogoUrl: boolean) {
    if(IsLogoUrl === undefined || IsLogoUrl === false) {
      if(this.isLogoImageClicked){
        this.eventWebPageData.EventWebPagesMetaData.LogoURL = imgurl.includes('data:image/png') ? '' : imgurl;
      } else{
        this.eventWebPageData.EventWebPagesMetaData.OGImageUrl = this.eventPageOGImageData.ImageUrl = imgurl.includes('data:image/png') ? '' : imgurl;
      }
    }
  }
  // Set background image url
  private SetBackgroundImageUrl(
    url: string,
  ) {
    if (this.clickedImageType === EventWebPageSectionType.OrganizerSection) {
      this.eventWebPageData.EventWebPagesMetaData.OrganizerImageUrl = url === undefined ? '' : url;
    } else if (this.clickedImageType === EventWebPageSectionType.BannerSection) {
      this.eventWebPageData.EventWebPagesMetaData.BannerImageURL = url === undefined ? '' : url;
    } else {
      this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections[this.selectedCustomSectionIndex].SectionImageUrl = this.customSectionImageContainerData[this.selectedCustomSectionIndex].ImageUrl = url === undefined ? '' : url;
    }
  }
  private SetLogoOldUrl() {
    if(this.isLogoImageClicked){
      this.eventWebPageData.EventWebPagesMetaData.LogoURL = this.oldEventWebPageData.EventWebPagesMetaData.LogoURL;
    } else{
      this.eventWebPageData.EventWebPagesMetaData.OGImageUrl = this.oldEventWebPageData.EventWebPagesMetaData.OGImageUrl;
    }
  }
  private SetFeatureOldUrl() {
    if(this.clickedImageType === EventWebPageSectionType.OrganizerSection) {
      this.eventWebPageData.EventWebPagesMetaData.OrganizerImageUrl = this.oldEventWebPageData.EventWebPagesMetaData.OrganizerImageUrl;
    } else if(this.clickedImageType === EventWebPageSectionType.BannerSection) {
      this.eventWebPageData.EventWebPagesMetaData.BannerImageURL = this.oldEventWebPageData.EventWebPagesMetaData.BannerImageURL;
    } else {
      this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections[this.selectedCustomSectionIndex].SectionImageUrl = this.oldEventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections[this.selectedCustomSectionIndex].SectionImageUrl;
    }
  }
  // This filter out custom sections which are not deleted
  private FilterCustomSectionData() {
    if(!!this.eventWebPageData && !!this.eventWebPageData.EventWebPagesMetaData && !!this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections) {
      return this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections.filter((item) => !item.IsDeleted);
    }
  }
  // This is used to set data for custom image section
  private SetCustomSectionImageContainerData() {
    // Check if custom section is neither null nor undefined
    if(!!this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections) {
      this.customSectionImageContainerData = [];
      this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections.forEach((item)=> {
        this.customSectionImageContainerData.push(this.GetImageData(item.SectionImageUrl));
      });
    }
  }
  // Used to create and return object for corresponding image container
  private GetImageData(imageUrl: string) {
    // Create empty object for custom section image container
    const customSectionImageData: ImageContainerViewModel = ImageContainerViewModel.createEmpty();
    // Set data for custom section image container
    customSectionImageData.ImageDescription = this.GetBackgroundImageWarning();
    customSectionImageData.ShowImageDescription = true;
    customSectionImageData.ImageUrl = imageUrl;
    return customSectionImageData;
  }
  // Warning message for logo image
  private GetLogoWarning() {
    return this.$t('EventSetting.CustomTheme.LogoWarning',{size: EventWebPageHelper.LogoMaxSize,height: EventWebPageHelper.LogoMinHeight});
  }
  // Warning message for organizer and banner image
  private GetBackgroundImageWarning() {
    return this.$t('ImageProcess.BackgroundImageMessage',{backgroundImageWidthRatio: EventWebPageHelper.BackgroundImageWidthRatio, backgroundImageHeightRatio: EventWebPageHelper.BackgroundImageHeightRatio, maxBackgroundImageSize: EventWebPageHelper.BackgroundImageMaxSize, backgroundImageWidth: EventWebPageHelper.BackgroundImageMaxWidth, backgroundImageHeight:EventWebPageHelper.BackgroundImageMaxHeight});
  }
  // Warning message for OG image
  private GetOGImageWarning() {
    return this.$t('EventWebpage.SocialImageUploadNote',{size: EventWebPageHelper.OGImageSize, givenWidth: EventWebPageHelper.OGImageMinWidth, givenHeight:EventWebPageHelper.OGImageMinHeight});
  }
  private GetImageUrl() {
    if( this.isLogoImageClicked) {
      // If logo image is clicked
      return (this.eventWebPageData.EventWebPagesMetaData.LogoURL === null || this.eventWebPageData.EventWebPagesMetaData.LogoURL === undefined || this.eventWebPageData.EventWebPagesMetaData.LogoURL === '') ? this.missingImage : this.eventWebPageData.EventWebPagesMetaData.LogoURL;
    } else{
      return (this.eventWebPageData.EventWebPagesMetaData.OGImageUrl === null || this.eventWebPageData.EventWebPagesMetaData.OGImageUrl === undefined || this.eventWebPageData.EventWebPagesMetaData.OGImageUrl === '') ? this.missingImage : this.eventWebPageData.EventWebPagesMetaData.OGImageUrl;
    }
  }
  private GetStartDate() {
    return this.eventWebPageData.EventWebPagesMetaData.StartDate;
  }
  private GetEndDate() {
    return this.eventWebPageData.EventWebPagesMetaData.EndDate;
  }
  private CloseValidationSummary(val: boolean) {
    this.isValidationSummaryVisible = val;
  }
  private CloseVueModalPopUp() {
    this.showVueModalPopUp = false;
    this.isSocialSharingGuidelineClicked = false;
  }
  private CloseAnalyticsModalPopup() {
    this.showAnalyticsModalPopup = false;
  }
  private CloseDetailModalPopUp() {
    this.isPopupVisible = false;
  }
  // Setting value for start date
  private SetSelectedStartDate(date: Date) {
    if (date !== null && date !== undefined) {
      // Changing the value of end date if start date exceeds end date
      if(date > this.eventWebPageData.EventWebPagesMetaData.EndDate) {
        this.eventWebPageData.EventWebPagesMetaData.EndDate = date;
      }
      this.eventWebPageData.EventWebPagesMetaData.StartDate = date;
    }
  }
  // Setting value for end date
  private SetSelectedEndDate(date: Date) {
    if (date !== null && date !== undefined) {
      this.eventWebPageData.EventWebPagesMetaData.EndDate = date;
    }
  }
  // Setting value of about section description
  private SetAboutDescription(description: string) {
    if (description !== null && description !== undefined) {
      this.eventWebPageData.EventWebPagesMetaData.AboutSectionDescription = description;
    }
  }
  // Setting value of organizer section description
  private SetOrganizerDescription(description: string) {
    if (description !== null && description !== undefined) {
      this.eventWebPageData.EventWebPagesMetaData.OrganizerDescription = description;
      this.eventPageOrganizerImageData.ValidateLogo = false;
    }
  }
  // Setting description of custom section oon the basis of index
  private SetCustomSectionDescription(description: string, index: number) {
    if (description !== null && description !== undefined) {
      this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections[index].SectionDescription = description;
      this.customSectionImageContainerData[index].ValidateLogo = false;
    }
  }
  // Used for disabling fields when either it is mobile view or the section is unchecked
  private DisableFields(val: boolean) {
    return this.isMobileView || val;
  }
  // Used for preventing the change in the button url when either it is 'use ventla invitee' or it is mobile view
  private DisableCTAButtonUrl() {
    return this.eventWebPageData.EventWebPagesMetaData.CTAButtonType === EventWebPageButtonType.VentlaInviteLink || this.isMobileView;
  }
  // Used for showing message when selected button type is 'use ventla invitee' and invitee is not published
  private IsInviteePublished() {
    return !this.eventWebPageData.IsInviteePublished && this.eventWebPageData.EventWebPagesMetaData.CTAButtonType === EventWebPageButtonType.VentlaInviteLink;
  }
  private CopyPublicLinkToClipboard() {
    this.showCopiedMessage = Common.copyPublicLinkToClipboard(
      this.GetPublishedLink(),
    );
    if (this.showCopiedMessage) {
      setTimeout(() => {
        this.showCopiedMessage = false;
      }, this.linkCopiedFadeoutTime);
    }
  }
  private GetPublishedLink() {
    return this.staticPath + this.eventWebPageData.AppEncodedName + '/' + this.eventWebPageData.EventWebPages.EncodedPath;
  }
  // Used for showing preview page
  private GetPreviewLink() {
    return this.staticPath + this.eventWebPageData.AppEncodedName + '/' + this.eventWebPageData.EventWebPages.EncodedPath + '/' + this.eventWebPageData.EventWebPages.PreviewGUID;
  }

  // Used to add custom sections
  private AddCustomSection() {
    if(!!this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections && !this.isMobileView) {
      // Create empty custom section object
      const customSection = EventWebPageCustomSectionsViewModel.createEmpty();
      // Set meta data id to preview version id
      customSection.EventWebPagesMetaDataId = this.eventWebPageData.EventWebPages.PreviewVersionId;
      // Push the section to the existing ones
      this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections.push(customSection);
      this.customSectionImageContainerData.push(this.GetImageData(''));
    }
  }

  // Used to remove custom sections
  private RemoveSection(index: number) {
    if(!this.isMobileView) {
      // Remove selected section
      if(this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections[index].Id !== 0) {
        // Remove the custom section object from array of objects
        const customSection = this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections.splice(index, 1);
        customSection[0].IsDeleted = true;
        // Push the removed object into deleted custom sections array of object
        this.deletedCustomSection.push(customSection[0]);
        // Remove the custom section object from customSectionImageContainerData
        this.customSectionImageContainerData.splice(index, 1);
      } else {
        // Don't store the removed object into delted ones if id = 0(i.e., unsaved object)
        this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections.splice(index, 1);
        this.customSectionImageContainerData.splice(index, 1);
      }
    }
  }
  private SaveAndPublish() {
    this.isPublished = true;
    this.Save();
  }
  private Publish(data: DetailModalPopupViewModel) {
    // Setting the values received
    this.eventWebPageData.EventWebPages.HidePageFromSearchEngines = data.HidePageFromSearchEngines;
    this.eventWebPageData.EventWebPages.GoogleTagId = data.GoogleTagId;
    this.eventWebPageData.EventWebPages.Path = data.Path;
    this.CloseDetailModalPopUp();
    this.SetModalPopupData();
    if(!this.eventWebPageData.EventWebPages.IsPublished) {
      this.eventWebPageData.EventWebPages.Id = 0;
    }
    if(data.Button2Text === this.$t('Publish').toString()) {
      this.isPublished = true;
      this.Save();
    }
    this.SavePublishSettings();
  }
  // Save publish settings(i.e, path, hide from search engine)
  private SavePublishSettings() {
    if(this.eventWebPageData.EventWebPages.IsPublished) {
      this.showLoading = true;
    }
    FetchData('/EventWebPage/SavePublishSettingsOfEventWebPage', JSON.stringify({
      path: this.eventWebPageData.EventWebPages.Path,
      hidePageFromSearchEngines: this.eventWebPageData.EventWebPages.HidePageFromSearchEngines,
      googleTagId: this.eventWebPageData.EventWebPages.GoogleTagId,
    })).then((response)=> {
      if(response && this.eventWebPageData.EventWebPages.IsPublished) {
        this.eventWebPageData.EventWebPages.EncodedPath = this.oldEventWebPageData.EventWebPages.EncodedPath = response;
        this.detailModalPopupData.EncodedPath = response;
        this.ShowToasterAndLoader(this.$t('SavedSuccessfully').toString());
        this.oldEventWebPageData.EventWebPages.Path = this.eventWebPageData.EventWebPages.Path;
        this.oldEventWebPageData.EventWebPages.HidePageFromSearchEngines = this.eventWebPageData.EventWebPages.HidePageFromSearchEngines;
        this.oldEventWebPageData.EventWebPages.GoogleTagId = this.eventWebPageData.EventWebPages.GoogleTagId;
      }
    }).catch(()=> {
      this.showLoading = false;
    });
  }
  // Used for unpublishing the page
  private Unpublish() {
    this.showLoading = true;
    FetchData('/EventWebPage/UnpublishEventWebPage', '').then((response)=> {
      if(response) {
        this.isPublished = false;
        this.eventWebPageData.EventWebPages.IsPublished = false;
        this.oldEventWebPageData.EventWebPages.IsPublished = false;
        this.detailModalPopupData.Button2Text = this.$t('Publish').toString();
        this.ShowToasterAndLoader(this.$t('UnPublished').toString() );
      }
    }).catch(()=> {
      this.showLoading = false;
    });
  }
  private ShowPopup() {
    if(this.eventWebPageData.EventWebPages.IsPublished) {
      this.ShowVueModalPopUp();
    } else {
      this.ShowDetailModalPopUp();
    }
  }
  // For publish, save & publish
  private ShowVueModalPopUp() {
    this.subModuleName = '';
    // Setting the popoup data
    this.publishModalPopUp = new VueModalPopUpViewModel(
      this.$t('Publish').toString() ,
      this.$t('EventWebpage.VueModalPopUpSavedDraftPageDescription').toString() ,
      false,
      '',
      this.$t('CancelButton').toString() ,
      this.$t('Publish').toString() ,
    );
    this.isSavedAndPublished = false;
    if(this.isPageDirty) {
      // If page is dirty then it is the case of save and publish and hence setting the data for popup accordingly
      this.publishModalPopUp.Button2Text = this.$t('SaveAndPublish').toString();
      this.isSavedAndPublished = true;
      this.publishModalPopUp.ModelDescription = this.$t('EventWebpage.VueModalPopUpUnSavedDraftPageDescription').toString();
    }
    this.showVueModalPopUp = true;
  }
  // For publish and save publish settings(i.e., path, hide from searh engine)
  private ShowDetailModalPopUp() {
    if(this.eventWebPageData.EventWebPages.IsPublished) {
      this.detailModalPopupData.Button2Text = this.$t('Button.Save').toString();
      this.isSavedAndPublished = false;
    }
    this.isPopupVisible = true;
  }
  private ShowGuidelineModalPopup() {
    this.subModuleName = SubModulePrefix.OGImage;
    // Setting the popoup data
    this.publishModalPopUp = new VueModalPopUpViewModel(
      this.$t('EventWebpage.SocialSharingImageRecommendationTitle').toString() ,
      this.$t('EventWebpage.SocialSharingImageRecommendations').toString() ,
      false,
      '',
      this.$t('Button.Close').toString() ,
      '' ,
    );
    this.isSocialSharingGuidelineClicked = true;
    this.showVueModalPopUp = true;
  }
  // Used for checking whether page contains unsaved data
  private IsPageDirty() {
    const objectState = (JSON.stringify(this.oldEventWebPageData) === JSON.stringify(this.eventWebPageData));
    if (!objectState) {
      this.isPageDirty = true;
    } else {
      this.isPageDirty = false;
    }
  }
  // Checking whether any required field is empty
  private ValidateData() {
    // Taken const variable to shorten the length of checks
    const self = this.eventWebPageData.EventWebPagesMetaData;
    if((self.AboutSectionTitle === '' || self.AboutSectionTitle === null) && self.ShowAboutSection || (self.ScheduleSectionTitle === '' || self.ScheduleSectionTitle === null) && self.ShowScheduleSection || (self.OrganizerSectionTitle === '' || self.OrganizerSectionTitle === null) && self.ShowOrganizer || (self.VenueSectionTitle === '' || self.VenueSectionTitle === null) && self.ShowVenue || (self.CTAButtonTitle === '' || self.CTAButtonTitle === null) && self.CTAButtonType !== EventWebPageButtonType.NoAction || (self.SponsorSectionTitle === '' || self.SponsorSectionTitle === null) && self.ShowSponsors || (self.SpeakerSectionTitle === '' || self.SpeakerSectionTitle === null) && self.ShowSpeakers || (!!self.EventWebPageCustomSections && self.EventWebPageCustomSections.some((item) => item.ShowSection && (item.SectionTitle === null || item.SectionTitle === '')))) {
      this.validationErrorFields.push(this.$t('Title').toString() );
    }
    if(self.FooterText === '' || self.FooterText === null) {
      this.validationErrorFields.push(this.$t('FooterText').toString() );
    }
    if((self.AboutSectionDescription === '' || self.AboutSectionDescription === null) && self.ShowAboutSection) {
      this.validationErrorFields.push(this.$t('Description').toString() );
    }
    if(self.BannerImageURL === '' || self.BannerImageURL === null) {
      this.validationErrorFields.push(this.$t('BannerImage').toString() );
      this.eventPageBannerImageData.ValidateLogo = true;
    }
    if(((self.OrganizerImageUrl === '' || self.OrganizerImageUrl === null) && (self.OrganizerDescription === '' || self.OrganizerDescription === null)) && self.ShowOrganizer) {
      this.validationErrorFields.push(this.$t('ImageOrDescription').toString() );
      this.eventPageOrganizerImageData.ValidateLogo = true;
    }
    if(self.LogoURL === '' || self.LogoURL === null) {
      this.validationErrorFields.push(this.$t('Logo').toString() );
      this.eventPageLogoData.ValidateLogo = true;
    }
    if((self.Address === '' || self.Address === null) && self.ShowVenue) {
      this.validationErrorFields.push(this.$t('StreetAddress').toString() );
    }
    if((self.City === '' || self.City === null) && self.ShowVenue) {
      this.validationErrorFields.push(this.$t('City').toString() );
    }
    if(!this.isButtonUrlValid && self.CTAButtonType !== EventWebPageButtonType.NoAction) {
      this.validationErrorFields.push(this.$t('InvalidUrl').toString() );
    }
    if((self.OGImageUrl === '' || self.OGImageUrl === null) && self.OGButtonType === this.selectedOGImageType.CustomSocialImage) {
      this.validationErrorFields.push(this.$t('EventWebpage.SocialSharingImage').toString() );
      this.eventPageOGImageData.ValidateLogo = true;
    }
    if(!!self.EventWebPageCustomSections && self.EventWebPageCustomSections.some((item) => item.ShowSection && (item.SectionImageUrl === null || item.SectionImageUrl === '') && (item.SectionDescription === null || item.SectionDescription === ''))) {
      this.validationErrorFields.push(this.$t('ImageOrDescription').toString());
      self.EventWebPageCustomSections.forEach((item, index) => {
        if((item.SectionImageUrl === null || item.SectionImageUrl === '') && (item.SectionDescription === null || item.SectionDescription === '')) {
          this.customSectionImageContainerData[index].ValidateLogo = true;
        }
      });
    }
  }
  // Used for validating input fields and making border red if invalid
  private ValidateInputField(name: string, isFieldEmpty: boolean, isRequired: boolean) {
    return this.validationErrorFields.includes(name) && isFieldEmpty && isRequired;
  }
  // Used for validating organiser section such that atleast one of logo or description is provided
  private IsOrganizerLogoOrDescriptionRequired() {
    if(this.eventWebPageData !== null && this.eventWebPageData !== undefined && this.eventWebPageData.EventWebPagesMetaData !== null && this.eventWebPageData.EventWebPagesMetaData !== undefined) {
      return this.eventWebPageData.EventWebPagesMetaData.OrganizerImageUrl === '' && this.eventWebPageData.EventWebPagesMetaData.OrganizerDescription === '';
    }
  }
  // Used to check whether both image and description of custom section is empty
  private IsCustomSectionImageOrDescriptionRequired(index: number) {
    if(!!this.eventWebPageData && !!this.eventWebPageData.EventWebPagesMetaData  && !!this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections) {
      return this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections[index].SectionImageUrl === '' && this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections[index].SectionDescription === '';
    }
  }

  private GetIconImageHeight() {
    return this.subModuleName === SubModulePrefix.IconImage ? undefined : EventWebPageHelper.OGImageHeight;
  }
  private GetIconImageHeightRatio() {
    return this.subModuleName === SubModulePrefix.IconImage ? undefined : EventWebPageHelper.OGImageHeightRatio;
  }
  private GetIconImageWidth() {
    return this.subModuleName === SubModulePrefix.IconImage ? undefined : EventWebPageHelper.OGImageWidth;
  }
  private GetIconImageWidthRatio() {
    return this.subModuleName === SubModulePrefix.IconImage ? undefined : EventWebPageHelper.OGImageWidthRatio;
  }
  // Saving the data
  private Save() {
    this.validationErrorFields = [];
    this.CloseVueModalPopUp();
    this.ValidateData();
    if(this.validationErrorFields.length !==0) {
      this.isValidationSummaryVisible = true;
      Common.ScrollToTop('dvEventWebPageParent');
    } else {
      const toasterMessage = this.isPublished ? this.$t('PublishedSuccessfully').toString() : this.$t('SavedSuccessfully').toString();
      const reqInfo: AppRequestInfo = this.storeHelper.GetRequestInfoFromStore();
      this.eventWebPageData.IsEventWebPageEnabled = reqInfo.EnableEventWebPage;
      this.eventWebPageData.IsEventWebPagePFActive = reqInfo.IsEventWebPagePFActive;
      // Add the deleted objects whose id's were not 0 into the custom sections array of object such that they can be updated in DB
      if(!!this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections && this.deletedCustomSection.length !== 0) {
        this.eventWebPageData.EventWebPagesMetaData.EventWebPageCustomSections.push(...this.deletedCustomSection);
      }
      this.showLoading = true;
      this.isValidationSummaryVisible = false;
      const objForJson = {
        Latitude: this.eventWebPageData.EventWebPagesMetaData.Latitude,
        Longitude: this.eventWebPageData.EventWebPagesMetaData.Longitude,
      };
      if(this.eventWebPageData.EventWebPagesMetaData.OGButtonType === this.selectedOGImageType.UseLogoAsSocialImage){
        this.eventWebPageData.EventWebPagesMetaData.OGImageUrl = '';
      }

      FetchData('/EventWebPage/SaveOrUpdateEventWebPages', JSON.stringify({
        eventWebPagePublicViewDto: this.eventWebPageData,
        isPublished: this.isPublished,
        isSavedAndPublished: this.isSavedAndPublished,
        jsonData : JSON.stringify(objForJson),
      })).then((response) => {
        if(response) {
          this.GetEventWebPageData();
          this.ShowToasterAndLoader(toasterMessage );
          this.isPublished = false;
          this.isSavedAndPublished = false;
          this.externalLinkUrl = '';
        } else {
          this.showLoading = false;
        }
      })
        .catch(() => {
          this.showLoading = false;
        });
    }
  }
  // Common function for showing and hiding toaster message and loader
  private ShowToasterAndLoader(toasterMessage: string) {
    this.toasterMessage = toasterMessage;
    this.showToaster = true;
    setTimeout(() => {
      this.showLoading = false;
      setTimeout(() => {
        this.showToaster = false;
      }, 2000);
    }, 1000);
  }
  // Discarding the changes made
  private Discard() {
    this.eventWebPageData = JSON.parse(JSON.stringify(this.oldEventWebPageData));
    this.isValidationSummaryVisible = false;
    this.validationErrorFields = [];
    this.externalLinkUrl = '';
    this.eventPageBannerImageData.ValidateLogo = false;
    this.eventPageLogoData.ValidateLogo = false;
    this.eventPageOrganizerImageData.ValidateLogo = false;
    this.eventPageOGImageData.ValidateLogo = false;
    this.SetCustomSectionImageContainerData();
    this.deletedCustomSection = [];
  }
  private getInformationString(val: boolean) {
    this.showOverlayInfo = val;
  }
  // Watches for handling the change in palettes colors
  @Watch('PrimaryBackgroundColor')
  private CheckChangeInPrimaryBackgroundColor(newColor: { hex: '' }) {
    this.eventWebPageData.EventWebPageThemeSettings.PrimaryBackgroundColor = newColor.hex;
  }
  @Watch('PrimaryFontColor')
  private CheckChangeInPrimaryFontColor(newColor: { hex: '' }) {
    this.eventWebPageData.EventWebPageThemeSettings.PrimaryFontColor = newColor.hex;
  }
  @Watch('HeaderFooterBackgroundColor')
  private CheckChangeInHeaderFooterBackgroundColor(newColor: { hex: '' }) {
    this.eventWebPageData.EventWebPageThemeSettings.HeaderFooterBackgroundColor = newColor.hex;
  }
  @Watch('HeaderFooterFontColor')
  private CheckChangeInHeaderFooterFontColor(newColor: { hex: '' }) {
    this.eventWebPageData.EventWebPageThemeSettings.HeaderFooterFontColor = newColor.hex;
  }
  @Watch('ButtonAccentBackgroundColor')
  private CheckChangeInButtonAccentBackgroundColor(newColor: { hex: '' }) {
    this.eventWebPageData.EventWebPageThemeSettings.ButtonAccentBackgroundColor = newColor.hex;
  }
  @Watch('ButtonAccentFontColor')
  private CheckChangeInButtonAccentFontColor(newColor: { hex: '' }) {
    this.eventWebPageData.EventWebPageThemeSettings.ButtonAccentFontColor = newColor.hex;
  }
  @Watch('LinkFontColor')
  private CheckChangeInLinkFontColor(newColor: { hex: '' }) {
    this.eventWebPageData.EventWebPageThemeSettings.LinkFontColor = newColor.hex;
  }
  @Watch('eventWebPageData.EventWebPagesMetaData', {deep: true})
  private CheckChangeInMetaData(val: EventWebPagesMetaDataViewModel) {
    this.eventPageLogoData.ImageUrl = val.LogoURL;
    this.eventPageBannerImageData.ImageUrl = val.BannerImageURL;
    this.eventPageOrganizerImageData.ImageUrl = val.OrganizerImageUrl;
    this.eventPageOGImageData.ImageUrl = val.OGImageUrl;
    if(this.eventPageLogoData.ImageUrl !== '') {
      this.eventPageLogoData.ValidateLogo = false;
    }
    if(this.eventPageBannerImageData.ImageUrl !== '') {
      this.eventPageBannerImageData.ValidateLogo = false;
    }
    if(this.eventPageOrganizerImageData.ImageUrl !== '') {
      this.eventPageOrganizerImageData.ValidateLogo = false;
    }
    if(this.eventPageOGImageData.ImageUrl !== '') {
      this.eventPageOGImageData.ValidateLogo = false;
    }
  }
}
export default toNative(EventWebpageEditPane);
